export const AUTH_BROADCAST_CHANNEL = 'moi_auth_channel';

export enum AUTH_BROADCAST_MESSAGE {
  LOGOUT = 'LOGOUT'
}

let authChannelInstance: BroadcastChannel | null = null;

export const getAuthBroadcastChannel = (): BroadcastChannel | null => {
  if (typeof window !== 'undefined' && 'BroadcastChannel' in window) {
    if (!authChannelInstance) {
      authChannelInstance = new BroadcastChannel(AUTH_BROADCAST_CHANNEL);
    }
    return authChannelInstance;
  }
  return null;
};

export const broadcastLogout = () => {
  try {
    getAuthBroadcastChannel()?.postMessage({ type: AUTH_BROADCAST_MESSAGE.LOGOUT });
  } catch (error) {
    console.error('Failed to post message to BroadcastChannel:', error);
  }
};
